import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Actions = styled(View, theme => {
  return {
    base: {
      alignItems: 'flex-end',
      gap: theme.spacingInlineTwopulse,
      padding: theme.paddingInsetNone,
    },
    variants: {},
  }
})
